// DAS-70 Wave-A · P0-2: 404 페이지 (catch-all 라우트 대응)
// silver 토큰만 사용. 공통 HexLogo + 홈 복귀 링크. 프로젝트 class 컴포넌트 컨벤션 유지.

import React from 'react';
import { Link } from 'react-router-dom';
import { HexLogo } from '../components/common/claude_primitives';

class NotFoundPage extends React.Component {
    render() {
        return (
            <div className="relative flex min-h-screen items-center justify-center bg-surface px-4">
                {/* 배경 ambient glow (silver 토큰) */}
                <div className="pointer-events-none absolute inset-0 overflow-hidden">
                    <div className="absolute left-1/2 top-1/3 -translate-x-1/2 -translate-y-1/2 h-[500px] w-[500px] rounded-full bg-brand-subtle blur-[120px]" />
                </div>

                <div className="relative w-full max-w-sm animate-fade-in text-center">
                    <div className="mb-6 flex flex-col items-center gap-3">
                        <div className="flex h-12 w-12 items-center justify-center rounded-2xl border-[1.5px] border-content">
                            <HexLogo size={28} />
                        </div>
                        <span className="text-sm font-bold tracking-wide text-content">MyDashboard</span>
                    </div>

                    <div className="bg-glass rounded-2xl border border-surface-border p-6 shadow-elevated">
                        <p className="font-num text-4xl font-bold text-content">404</p>
                        <h1 className="mt-3 text-lg font-semibold text-content">페이지를 찾을 수 없습니다</h1>
                        <p className="mt-2 text-sm text-content-secondary">
                            요청하신 경로는 존재하지 않거나 이동되었을 수 있습니다.
                        </p>
                        <div className="mt-6">
                            <Link
                                to="/dashboard"
                                className="inline-flex items-center justify-center rounded-lg bg-gradient-brand px-4 py-2.5 text-sm font-semibold text-content-inverse shadow-glow-brand/30 transition-all hover:shadow-glow-brand hover:brightness-110 active:scale-[0.98]"
                            >
                                홈으로 돌아가기
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NotFoundPage;
